import { render } from "./EnvioMagicLinkUsuario.vue?vue&type=template&id=3f936abe&scoped=true"
import script from "./EnvioMagicLinkUsuario.vue?vue&type=script&lang=js"
export * from "./EnvioMagicLinkUsuario.vue?vue&type=script&lang=js"

import "./EnvioMagicLinkUsuario.vue?vue&type=style&index=0&id=3f936abe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f936abe"]])

export default __exports__